import { IMessagingSettings } from '@dataTypes/messaging-settings.type'
import {
  fetchMessagingSettingsByClinic,
  saveMessagingSettings,
} from '@store/actions'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface MessagingSettingsState {
  current: IMessagingSettings | null
  loading: boolean
  error: string | null
}

const initialState: MessagingSettingsState = {
  current: null,
  loading: false,
  error: null,
}

const messagingSettingsSlice = createSlice({
  name: 'messagingSettings',
  initialState,
  reducers: {
    upsertMessagingSettingsLocal: (
      state,
      action: PayloadAction<IMessagingSettings>,
    ) => {
      state.current = action.payload
    },
    clearMessagingSettings: (state) => {
      state.current = null
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMessagingSettingsByClinic.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchMessagingSettingsByClinic.fulfilled, (state, action) => {
        state.loading = false
        state.current = action.payload[0] ?? null
      })
      .addCase(fetchMessagingSettingsByClinic.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload ?? 'Failed to load messaging settings'
      })
      .addCase(saveMessagingSettings.fulfilled, (state, action) => {
        state.current = action.payload
      })
  },
})

export const { upsertMessagingSettingsLocal, clearMessagingSettings } =
  messagingSettingsSlice.actions
export default messagingSettingsSlice.reducer
